<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import {
  faCheckCircle,
  faCircleExclamation,
  faCircleNotch,
} from '@fortawesome/pro-solid-svg-icons';
import { useFaIcons } from '@gportal/uikit';

withDefaults(
  defineProps<{ isLoading?: boolean; isDone?: boolean; isInvalid?: boolean; delay?: number }>(),
  {
    isDone: false,
    isLoading: false,
    isInvalid: false,
    delay: 0,
  },
);

useFaIcons({ faCircle, faCheckCircle, faCircleExclamation, faCircleNotch });
</script>

<template>
  <transition :name="isDone ? 'zoom-in' : 'fade'" :duration="delay">
    <FontAwesomeIcon
      v-if="isInvalid"
      :icon="['fas', 'fa-circle-exclamation']"
      class="tw-text-xl tw-text-gp-orange"
    />
    <FontAwesomeIcon
      v-else-if="isDone"
      :icon="['fas', 'fa-check-circle']"
      class="tw-text-xl tw-text-gp-cyan"
      :style="{ 'transition-delay': `${delay}ms` }"
    />
    <FontAwesomeIcon
      v-else-if="isLoading"
      :icon="['fas', 'fa-circle-notch']"
      class="fa-spin tw-text-xl tw-text-gp-rhino"
    />
    <FontAwesomeIcon v-else :icon="['far', 'fa-circle']" class="tw-text-xl tw-text-gp-rhino" />
  </transition>
</template>

<style scoped>
.zoom-in-enter-active {
  transition: transform 0.2s ease-in;
}

.zoom-in-leave-active {
  transition: opacity 0.2s ease-out;
  position: absolute;
  top: 0.4rem;
  left: 0.5rem;
}

.zoom-in-enter-from {
  transform: scale(0);
}

.zoom-in-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-active {
  /* override the default transition to support absolute positioning */
  transition: opacity 0.2s ease-out;
  position: absolute;
  top: 0.4rem;
  left: 0.5rem;
}
</style>
